import React from 'react';

const InstitutionContext = React.createContext({
    institutionData: {
        PrimaryColor: '#1a73e8',
        SecondaryColor: '#4285f4',
        lightPrimaryColor: '#e8f0fe'
    }
});

export default InstitutionContext;